// @flow

import React, { Component } from 'react';
import _ from 'lodash'

import I18n from 'PMT/i18n/I18n';

// -- constants
import Events from 'constants/Events';
import RoutingEnum from 'constants/RoutingEnum';

// -- utils
import { ViewUtils, Utils } from 'PMT/utils';
import Listener from 'PMT/flux/Listener';

// -- actions
import RouteAction from 'actions/RouteAction';
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- stores
import SessionStore from 'stores/SessionStore';
import RestaurantMenuStore from 'stores/RestaurantMenuStore';
import RestaurantStore from 'stores/RestaurantStore';


// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import ProductCategory from 'PMT/entities/menu/ProductCategory';

// -- components
import RestaurantMenuTabs from "pages/menu/RestaurantMenuTabs";
import AbstractComponent from 'components/AbstractComponent';
import Ariane from 'PMT/components/Ariane';
import ProductCategoryDetailView from './ProductCategoryDetailView';

class ProductCategoryDetailPage extends AbstractComponent {

  state = {
    restaurantMenu: RestaurantMenuStore.getRestaurantMenu(),
    restaurant: RestaurantStore.getRestaurant(),
    productCategory: null,
    apiError: null
  };

  componentDidMount() {
    RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);
    this.loadData(this.props.match.params.categoryId);
  }

  componentWillReceiveProps(newProps) {
    // route param have changed (we change the category to display)
    this.loadData(newProps.match.params.categoryId);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
  }

  loadData(productCategoryId) {
    if (_.isNull(this.state.restaurantMenu)) {
      this.showLoading();
      RestaurantMenuAction.loadRestaurantMenu();
    } else {
      this.loadProductCategory(productCategoryId);
    }
  }

  get restaurantMenuStoreListeners(): Array<Listener> {
    return [
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange),
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_CATEGORY_SUCCESS, this.onChange),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_CATEGORY_ERROR, this.onError),
      new Listener(Events.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS, this.onChange),
      new Listener(Events.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR, this.onError)
    ];
  }

  get productCategory(): ProductCategory {
    return this.state.productCategory;
  }

  get restaurantMenu(): RestaurantMenu {
    return this.state.restaurantMenu;
  }

  get restaurant(): Restaurant {
    return this.state.restaurant;
  }

  loadProductCategory(productCategoryId: string) {
    if (!_.isNull(this.state.restaurantMenu)) {
      const productCategory: ProductCategory = this.state.restaurantMenu.getCategoryWithId(productCategoryId);

      // category have been deleted are no longer exists
      if (_.isNull(productCategory)) {
        RouteAction.redirectTo(RoutingEnum.RESTAURANT_MENU);
      }

      this.setState({
        productCategory,
        loading: false
      });
    }
  }

  // -- Event functions

  onChange = () => {
    const restaurantMenu: RestaurantMenu = RestaurantMenuStore.getRestaurantMenu();
    const productCategory: ProductCategory = restaurantMenu.getCategoryWithId(this.props.match.params.categoryId);

    if (_.isNull(productCategory)) {
      this.setState({
        loading: false,
        // TODO: 404
      });
    } else {
      this.setState({
        restaurantMenu: restaurantMenu.copy(),
        productCategory: productCategory.copy(),
        loading: false
      });
    }
  };

  onError = () => {
    this.setState({
      apiError: RestaurantMenuStore.getApiError(),
      loading: false
    });
  };

  onUpdate = (category: ProductCategory, image = null) => {
    this.showLoading();
    const imageFile = _.isNull(image) ? null : ViewUtils.dataUriToFile(image);
    RestaurantMenuAction.saveCategory(category, imageFile);
  };

  onImageRemove = (category: ProductCategory) => {
    this.showLoading();
    RestaurantMenuAction.deleteCategoryImage(category);
  }

  //
  // renderers
  //

  renderBody() {
    if (!_.isNull(this.apiError)) {
      return this.renderApiErrorBlock();
    } else if (_.isNull(this.state.productCategory)) {
      return this.renderOnLoadingContent();
    }

    //
    // We use the uid to re-generate the sub view after a changement on the product category.
    //
    return (
      <ProductCategoryDetailView
        key={Utils.generateUID()}
        productCategory={this.productCategory}
        restaurantMenu={this.restaurantMenu}
        onUpdate={this.onUpdate}
        onImageRemove={this.onImageRemove}
        currencyCode={this.restaurant.currency}
      />
    );
  }

  render() {
    const arianeIcon = 'fa-shopping-cart';

    const arianeDetails = [
      {
        name: I18n.tr('menu.order'),
        link: null
      },
      {
        name: I18n.tr('menu.order.restaurant_menu'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.CATEGORIES
        }
      },
      {
        name: I18n.tr('menu.order.restaurant_menu.categories'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.CATEGORIES
        }
      },
      {
        name: !_.isNull(this.productCategory) ? this.productCategory.name : '',
        link: null
      }
    ];

    return (
      <div className="product_category_detail_page">
        <Ariane icon={arianeIcon} details={arianeDetails} />

        {this.renderBody()}
        {this.renderLoading()}
      </div>
    );
  }

}

export default ProductCategoryDetailPage;
